import React from 'react';

function ActionDefault({ fill = '#545659', width = 20, height = 20, style }) {
  return (
    <svg style={style} width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 18V12.4857H3.71429V16.2857H7.51429V18H2ZM2 7.51429V2H7.51429V3.71429H3.71429V7.51429H2ZM12.4857 18V16.2857H16.2857V12.4857H18V18H12.4857ZM16.2857 7.51429V3.71429H12.4857V2H18V7.51429H16.2857Z" fill={fill} />
    </svg>
  );
}

export default ActionDefault;
